import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedNumber } from 'react-intl';

import './ClassStats.scss';

class ClassStats extends Component {
  statBlock(title, count, style, decimals) {
    const { formatMessage } = this.props.intl;
    return (
      <div key={title} className="stat-block slds-col slds-size_1-of-3">
        <p className="title">{formatMessage({ id: title })}</p>
        <p className="count">
          <FormattedNumber
            value={count}
            maximumFractionDigits={decimals}
            style={style}
          />
        </p>
      </div>
    );
  }

  render() {
    const { summary } = this.props;
    const data = ['avg_selections', 'avg_ctor', 'avg_clicks'].map(feature => ({
      title: `components.ecs.analytics.classDetails.classStats.${feature}`,
      count: summary[feature],
      style: feature === 'avg_ctor' ? 'percent' : 'decimal',
      decimals: feature === 'avg_ctor' ? 2 : 0
    }));

    return (
      <div className="class-stats slds-grid slds-gutters slds-grid_vertical-align-center">
        {data.map(d => this.statBlock(d.title, d.count, d.style, d.decimals))}
      </div>
    );
  }
}

ClassStats.propTypes = {
  actions: PropTypes.object,
  assetType: PropTypes.string,
  assetTypes: PropTypes.array,
  summary: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(ClassStats);
